import { Grid } from "@mui/material"
import { FC } from "react"
import { HeaderTitle } from "../../atoms/header-title/header-title";
import TopRightButton from "../../common/top-right-button/top-right-button";

export interface IPosInnerPageLayoutProps {
    children: React.ReactNode;
    onClickBack?():void;
    title: string;
    backButton?: boolean;
}

export const PosInnerPageLayout:FC<IPosInnerPageLayoutProps>=({children, onClickBack, title, backButton=true })=>{
    return <Grid sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column"
    }}>
        {backButton && <TopRightButton variation="Back" onClick={onClickBack}/>}
        <HeaderTitle variation="page_header" title={title}/>
        {children}
    </Grid>
}
